import React, { useState } from "react";
import styled from "styled-components";
import emailjs from "emailjs-com";
import SEO from "./../components/SEO";

import Blad from './../images/blad.jpg';
import { useLanguage } from "../i18n";

const Form = styled.form`
  display: block;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
  padding: 3rem 6rem;
  background-color: white;
  background-image: url(${Blad});
  background-repeat: no-repeat;
  background-size: 20%;
  border-radius: 6px;
  border: double 4px;
  line-height: 1.4rem;

  h1 {
    text-align: center;
    font-size: 2.5rem;
  }

  input {
    width: 280px;
    margin-top: 0.6rem;
    margin-bottom: 0.6rem;
  }

  textarea {
    width: 100%;
    height: 130px;
  }

  button {
    padding: 1px 8px;
    border-radius: 12px;
    box-shadow: -1px 2px 2px #666;
    :hover {
      cursor: pointer;
    }
  }
`;

const Ingress = styled.p`
  margin-top: 1rem;
  display: block;
  text-align: center;
`;

const Fieldset = styled.fieldset`
  margin-top: 1rem;
  margin-bottom: 1rem;
  text-align: left;
  input {
    width: auto;
  }
  padding: 1rem;
`;

const Infobox = styled.div`
  margin-left: 1rem;
`;

const Tack = styled.p`
  text-align: center;
`;


const FormContent = () => {
    const [submitted, setSubmitted] = useState(false);
    const [name, setName] = useState("");
    const [message, setMessage] = useState("");
    const [annat, setAnnat] = useState("");
    const { t } = useLanguage();

    const handleSubmit = () => {

        const email = 'hej@oxelokrog.se';

        let checkboxes = document.getElementsByName("information");
        let info = "";
        for (let i = 0; i < checkboxes.length; i++) {
            if (checkboxes[i].checked)
                info += checkboxes[i].value + " ";
        }

        if (info) {
            const serviceId = "service_krogen";
            const templateId = "template_rknvn3g";
            const userId = "YDlI-kZs_WXHc0WPE";
            const templateParams = {
                name,
                email,
                message,
                info
            };

            emailjs
                .send(serviceId, templateId, templateParams, userId)
                .then((response) => console.log(response))
                .then((error) => console.log(error));

            setName("");
            setMessage("");
            setAnnat("");
            info = "";
            setSubmitted(true);
        } else {
            alert(t('formular.fillAllFields'));
        }
    };

    if (submitted) {
        return (
            <>
                <Tack>
                    <p>{t('formular.thankYou')}</p>
                    <p>{t('formular.thankYouFrom')} <br />{t('formular.thankYouOrg')}</p>
                </Tack>
            </>
        );
    }

    return (
        <Form onSubmit={handleSubmit} method="post" target="_blank">
            <h1>{t('formular.title')}</h1>
            <Ingress>
                {t('formular.ingress')}
            </Ingress>

            <Fieldset>
                <legend>{t('formular.legend')}<br />{t('formular.legendMultiple')}</legend>
                <Infobox>
                    <input type="checkbox" id="sn" name="information" value="sn" />
                    <label htmlFor="sn">{t('formular.sn')}</label>
                </Infobox>
                <Infobox>
                    <input type="checkbox" id="expresser" name="information" value="expressen" />
                    <label htmlFor="expressen">{t('formular.expressen')}</label>
                </Infobox>
                <Infobox>
                    <input type="checkbox" id="sormlandsleden" name="information" value="sormlandsleden" />
                    <label htmlFor="sormlandsleden">{t('formular.sormlandsleden')}</label>
                </Infobox>
                <Infobox>
                    <input type="checkbox" id="sörmlandskartan" name="information" value="sörmlandskartan" />
                    <label htmlFor="sörmlandskartan">{t('formular.sormlandskartan')}</label>
                </Infobox>
                <Infobox>
                    <input type="checkbox" id="utflyktsvägen" name="information" value="utflyktsvägen" />
                    <label htmlFor="utflyktsvägen">{t('formular.utflyktsvagen')}</label>
                </Infobox>
                <Infobox>
                    <input type="checkbox" id="vagskylten" name="information" value="vagskylten" />
                    <label htmlFor="vagskylten">{t('formular.vagskylten')}</label>
                </Infobox>
                <Infobox>
                    <input type="checkbox" id="orkesterjournalen" name="information" value="orkesterjournalen" />
                    <label htmlFor="orkesterjournalen">{t('formular.orkesterjournalen')}</label>
                </Infobox>
                <Infobox>
                    <input type="checkbox" id="fb" name="information" value="fb" />
                    <label htmlFor="fb">{t('formular.facebook')}</label>
                </Infobox>
                <Infobox>
                    <input type="checkbox" id="insta" name="information" value="insta" />
                    <label htmlFor="insta">{t('formular.instagram')}</label>
                </Infobox>
                <Infobox>
                    <input type="checkbox" id="affisch" name="information" value="affisch" />
                    <label htmlFor="affisch">{t('formular.affisch')}</label>
                </Infobox>
                <Infobox>
                    <input type="checkbox" id="flygbl" name="information" value="flygbl" />
                    <label htmlFor="flygbl">{t('formular.flygblad')}</label>
                </Infobox>
                <Infobox>
                    <input type="checkbox" id="visitOx" name="information" value="visitOx" />
                    <label htmlFor="visitOx">{t('formular.visitOx')}</label>
                </Infobox>
                <Infobox>
                    <input type="checkbox" id="NykGuiden" name="information" value="NykGuiden" />
                    <label htmlFor="NykGuiden">{t('formular.nykGuiden')}</label>
                </Infobox>
                <Infobox>
                    <input type="checkbox" id="VisitSorml" name="information" value="VisitSorml" />
                    <label htmlFor="VisitSorml">{t('formular.visitSorml')}</label>
                </Infobox>
                <Infobox>
                    <input type="checkbox" id="hörsägen" name="information" value="hörsägen" />
                    <label htmlFor="hörsägen">{t('formular.horsagen')}</label>
                </Infobox>
                <Infobox>
                    {t('formular.other')} <input
                        name="annat"
                        type="text"
                        placeholder={t('formular.otherPlaceholder')}
                        value={annat}
                        onChange={(e) => setAnnat(e.target.value)}
                    />
                </Infobox>
            </Fieldset>
            <div><br />
                <div>{t('formular.feedback')}</div>

                <textarea
                    name="message"
                    placeholder={t('formular.feedbackPlaceholder')}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                />{" "}
            </div>

            <p>
                {t('formular.nameOptional')} <input
                    name="name"
                    type="text"
                    placeholder={t('formular.namePlaceholder')}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                />
            </p>

            <button type="submit">{t('formular.send')}</button>
        </Form>
    );
};

function Formular() {

    return (
        <>
            <SEO pageKey="feedback" />
            <div>
                <FormContent />
            </div>
        </>
    );
}

export default Formular;
